"use client";

import { useState } from "react";
import { trackEmailCopy, trackEmailClick } from "../../../lib/trackConversion";
import {
  CheckIcon,
  ClipboardDocumentIcon,
  EnvelopeIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

const EMAIL = "info@alphaappraisals.ca";

export default function ProfileContactActions() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      trackEmailCopy();
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      trackEmailClick(EMAIL, "copy_email_fallback");
      window.location.href = `mailto:${EMAIL}`;
    }
  };

  return (
    <div className="mt-9 grid max-w-2xl gap-2.5">
      <a
        href="tel:+14164502336"
        className="group flex min-h-20 items-center gap-3 rounded-xl border border-slate-900/10 bg-white/80 p-3 text-left shadow-lg shadow-slate-900/10 backdrop-blur-xl transition hover:-translate-y-0.5 hover:border-blue-500/35 hover:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 sm:gap-4 sm:px-4 dark:border-white/15 dark:bg-slate-950/70 dark:shadow-black/20 dark:hover:border-blue-300/45 dark:hover:bg-slate-950/85 dark:focus:ring-blue-300"
      >
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-blue-300/30 bg-blue-600 text-white shadow-lg shadow-blue-950/30 transition group-hover:bg-blue-500">
          <PhoneIcon className="h-5 w-5" aria-hidden="true" />
        </span>
        <span className="min-w-0 font-gantari">
          <span className="block text-[10px] font-bold uppercase leading-4 tracking-[0.16em] text-blue-700 dark:text-blue-200">
            Speak with our designated appraiser
          </span>
          <span className="mt-1.5 block text-lg font-bold text-slate-950 sm:text-xl dark:text-white">
            (416) 450-2336
          </span>
        </span>
      </a>

      <div className="flex min-h-20 items-stretch overflow-hidden rounded-xl border border-slate-900/10 bg-white/80 p-2 shadow-lg shadow-slate-900/10 backdrop-blur-xl transition hover:border-blue-500/35 hover:bg-white dark:border-white/15 dark:bg-slate-950/70 dark:shadow-black/20 dark:hover:border-blue-300/40 dark:hover:bg-slate-950/85">
        <a
          href={`mailto:${EMAIL}`}
          className="flex min-w-0 flex-1 items-center gap-3 rounded-lg px-1 font-gantari text-slate-950 transition hover:bg-slate-900/[0.04] sm:gap-4 sm:px-1.5 dark:text-white dark:hover:bg-white/[0.04]"
        >
          <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-blue-300/30 bg-blue-600 text-white shadow-lg shadow-blue-950/30 sm:flex">
            <EnvelopeIcon className="h-5 w-5" aria-hidden="true" />
          </span>
          <span className="min-w-0">
            <span className="block text-[10px] font-bold uppercase tracking-[0.16em] text-blue-700 dark:text-blue-200">
              Email Alpha Appraisals
            </span>
            <span className="mt-1.5 block truncate text-[13px] font-semibold sm:text-base">{EMAIL}</span>
          </span>
        </a>
        <button
          type="button"
          onClick={copyEmail}
          className="ml-2 flex min-w-[68px] flex-col items-center justify-center gap-1 rounded-lg bg-blue-600 px-2 font-gantari text-[9px] font-bold uppercase tracking-[0.1em] text-white shadow-lg shadow-blue-950/30 transition hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 sm:min-w-[90px] sm:px-3 sm:text-[10px] sm:tracking-[0.12em]"
          aria-label="Copy Alpha Appraisals email address"
        >
          {copied ? (
            <CheckIcon className="h-5 w-5" aria-hidden="true" />
          ) : (
            <ClipboardDocumentIcon className="h-5 w-5" aria-hidden="true" />
          )}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
